"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ArrowForward_1 = __importDefault(require("@mui/icons-material/ArrowForward"));
const material_1 = require("@mui/material");
const react_router_1 = require("react-router");
const zustandStore_1 = require("../../../../zustandStore");
const MyCardHeader = (0, material_1.styled)(material_1.Typography)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: theme.typography.tsFontSize.mini,
    fontWeight: theme.typography.tsFontWeight.bold,
    paddingBottom: theme.tsGoUnit.tsUnitHalf,
}));
const MyCardItemHeader = ({ task }) => {
    const { setWalletPreviousPath, setPageLoading } = (0, zustandStore_1.useZustand)();
    const navigate = (0, react_router_1.useNavigate)();
    const goToWalletDetailsPage = () => {
        setPageLoading(true);
        setWalletPreviousPath(location.pathname);
        void navigate(`/wallet/${task?.id}`);
    };
    return ((0, jsx_runtime_1.jsxs)(MyCardHeader, { component: "p", "data-testid": "my-card-item-header", onClick: goToWalletDetailsPage, sx: {
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            paddingBottom: '10px',
            ...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                ? {
                    paddingBottom: 0,
                }
                : {}),
        }, children: [(0, jsx_runtime_1.jsx)(material_1.Tooltip, { title: task.context?.request.title || '', arrow: true, children: (0, jsx_runtime_1.jsx)("span", { style: {
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        maxWidth: 'calc(100% - 24px)', // Adjust width to fit the icon properly
                    }, children: task.context?.request.title || 'N/A' }) }), (0, jsx_runtime_1.jsx)(material_1.IconButton, { "data-testid": "my-card-item-header-icon", size: "small", sx: { padding: 0, alignSelf: 'baseline' }, children: (0, jsx_runtime_1.jsx)(ArrowForward_1.default, {}) })] }));
};
exports.default = MyCardItemHeader;
